export const tieredmenu = {
  root: {
    class: [
      'text-[16px] font-sans font-normal text-black',

      // Shape
      'rounded-md',

      // Size
      'min-w-48',
      'p-1',

      // Colors
      'border border-surface-200',

      'z-overlay',
    ],
  },
  rootList: {
    class: [
      // Spacings and Shape
      'list-none',
      'flex flex-col',
      'm-0 p-0',
      'outline-none',
      'rounded-md',
      'shadow',
    ],
  },
  item: {
    class: 'relative my-[2px] first:mt-0',
  },
  itemContent: ({ context }: Record<string, any>) => ({
    class: [
      // Shape
      'rounded-[4px]',

      // Colors
      {
        'bg-highlight text-highlight-contrast':
          (context.focused && context.active) ||
          context.active ||
          (!context.focused && context.active),
      },

      // Transitions
      'transition-shadow',
      'duration-200',

      // States
      {
        'hover:bg-grey-100': !context.active,
        'hover:bg-highlight-emphasis': context.active,
      },

      // Disabled
      { 'opacity-60 pointer-events-none cursor-default': context.disabled },
    ],
  }),
  itemLink: {
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'py-2',
      'px-3',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none',
      'text-black',
    ],
  },
  itemIcon: {
    class: [
      // Spacing
      'mr-2',
    ],
  },
  itemLabel: {
    class: ['leading-none'],
  },
  submenuIcon: {
    class: [
      // Position
      'ml-auto',
    ],
  },
  submenu: {
    class: [
      // Spacing
      'flex flex-col',
      'm-0',
      'p-1',
      'list-none',
      'min-w-50',

      // Shape
      'shadow-none sm:shadow-md',
      'border border-surface-200',

      // Position
      'static sm:absolute',
      'z-10',
    ],
  },
  separator: {
    class: 'border-t border-surface-200',
  },
  transition: {
    enterFromClass: 'opacity-0',
    enterActiveClass: 'transition-opacity duration-250',
  },
};
